import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'We need some more details to complete your registration.',
  firstname: 'First name',
  lastname: 'Last name',
  nameRequired: 'Please enter your name',
  accountNameRequired: 'Please enter a name',
  password: 'Password',
  confirmPassword: 'Confirm password',
  passwordRequired: 'Please enter your password.',
  confirmRequired: 'Please confirm your password.',
  passwordMissmatch: 'The two passwords do not match.',
  register: 'Activate account',
  registrationFailed: 'Failed to activate account, please try again later.',
  errorPasswordTooCommon: 'Password is too common',

  invalidLink: 'Invalid registration link',
  invalidLinkDesc: 'Maybe you are already registered, try resetting your password.',
  resetPassword: 'Reset password',
});
